export default "__VITE_ASSET__BRdDM5KW__"